module.exports = __webpack_public_path__ + "static/media/trust.35ced5ee.svg";